// src/plugins/i18n.ts
import { createI18n } from "vue-i18n";
import en from "./locales/en.json";
import zhCN from "./locales/zh-CN.json";

// 定义支持的语言类型，增强 TypeScript 支持
export type LocaleType = "en" | "zh-CN";

// 可以从 localStorage 或浏览器语言判断默认语言
function getDefaultLocale(): LocaleType {
  const stored = localStorage.getItem("app-locale");
  if (stored === "en" || stored === "zh-CN") return stored;
  // 检测浏览器语言
  const browserLang = navigator.language;
  if (browserLang.startsWith("zh")) return "zh-CN";
  return "en";
}

// 创建 i18n 实例
const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(),
  fallbackLocale: "en", // 找不到翻译时的回退语言
  messages: {
    en,
    "zh-CN": zhCN,
  },
  // 开启全局 $t 和 Composition API 的 useI18n
  globalInjection: true,
  // 处理复数等高级规则（保持默认即可）
  pluralRules: {
    "zh-CN": function () {
      return 1;
    },
  },
});

export default i18n;
